import React, {ReactNode} from 'react';

import {LazyTooltip} from 'app/components/general/LazyTooltip';
import {TooltipList} from 'app/components/general/TooltipList';
import {useAccountSettingsState} from 'app/settings/api';
import {getCategorizedUserTeams, getUserAccountRelation} from 'app/user/utils';
import {gt, ngt} from 'app/utils/i18n';

import {UserSerializedType, UserTeamSerializedType} from 'sweet-types';

interface Props {
  user: UserSerializedType;
}

export function InnerFullUserInfoCard({user}: Props): JSX.Element {
  const {owner_email} = useAccountSettingsState().data!;
  const relation = getUserAccountRelation(user, owner_email);
  const teams = getCategorizedUserTeams(user);

  return (
    <div className="small">
      {relation.super ? (
        <span className="font-weight-bold text-secondary">
          {relation.super ? <i className="fa fa-star mr-1" /> : null}
          {relation.name}
        </span>
      ) : (
        <>
          {teams.manager.length === 0 && teams.member.length === 0 ? (
            gt('In no teams')
          ) : (
            <>
              {teams.manager.length > 0
                ? teamsDescriptionWithTooltip(
                    ngt(
                      'Manager in %s team',
                      'Manager in %s teams',
                      teams.manager.length
                    ),
                    gt('Manager in'),
                    teams.manager
                  )
                : null}
              {teams.member.length > 0
                ? teamsDescriptionWithTooltip(
                    ngt(
                      'Regular member of %s team',
                      'Regular member of %s teams',
                      teams.member.length
                    ),
                    gt('Regular member of'),
                    teams.member
                  )
                : null}
            </>
          )}
        </>
      )}
    </div>
  );
}

function teamsDescriptionWithTooltip(
  content: ReactNode,
  tooltipTitle: ReactNode,
  teams: Array<UserTeamSerializedType>
): JSX.Element {
  return (
    <div>
      <LazyTooltip tooltip={<TooltipList title={tooltipTitle} items={teams} />}>
        <span style={{borderBottom: '1px dotted #CCC'}}>{content}</span>
      </LazyTooltip>
    </div>
  );
}
